import { Component } from '@theme/component';
class PurWelcome extends Component {
  connectedCallback() { super.connectedCallback(); this.setup(); }
  updatedCallback() { super.updatedCallback(); this.setup(); }
  setup() {
    this.controller?.abort();
    clearTimeout(this.timer);
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.dialog = this.querySelector('dialog');
    const trigger = this.querySelector('.ps-welcome__trigger');
    if (this.hasAttribute('data-editor')) return;
    if (!this.dialog || !trigger) return;
    let subscribed = false, dismissed = 0;
    try { subscribed = localStorage.getItem('pur-welcome-subscribed') === 'true'; dismissed = Number(localStorage.getItem('pur-welcome-dismissed') || 0); } catch { /* Native form works without storage. */ }
    if (subscribed || location.pathname === '/challenge') return;
    trigger.hidden = false;
    for (const opener of this.querySelectorAll('[data-open]')) opener.addEventListener('click', () => this.open(), { signal });
    for (const button of this.querySelectorAll('[data-close]')) button.addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') this.dialog.close();
    }, { signal });
    this.dialog.addEventListener('close', () => {
      try { localStorage.setItem('pur-welcome-dismissed', String(Date.now())); } catch { /* Optional preference. */ }
    }, { signal });
    // Invite eligible visitors after three seconds on desktop and mobile.
    if (Date.now() - dismissed > 7 * 24 * 60 * 60 * 1000 && !location.pathname.startsWith('/cart')) {
      this.timer = setTimeout(() => this.open(), 3000);
    }
  }
  open() {
    clearTimeout(this.timer);
    if (!this.dialog?.open && !document.querySelector('dialog[open]')) { this.dialog.classList.remove('ps-welcome__dialog--verifying'); this.dialog?.showModal(); }
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    this.controller?.abort();
    if (this.dialog?.open) this.dialog.close();
    super.disconnectedCallback();
  }
}
if (!customElements.get('ps-welcome')) customElements.define('ps-welcome', PurWelcome);
